import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles } from '@material-ui/core'
import React from 'react'
import { SPEC_INT_NAVY_COLOR } from '../../specIntelligenceConstants'

const useStyles = makeStyles(() => ({
    goToSectionLink: {
        display: 'inline-block',
        marginTop: pxToRem(10),
        fontSize: pxToRem(12),
        fontWeight: 500,
        color: SPEC_INT_NAVY_COLOR,
        cursor: 'pointer',
        '&:hover': { textDecoration: 'underline' },
    },
}))

export interface GoToSectionLinkProps {
    projectId: string
    sectionElementId: string
}

/** Link to open a finding's referenced section in the workspace, shown on read-only finding cards. */
const GoToSectionLink = ({ projectId, sectionElementId }: GoToSectionLinkProps) => {
    const classes = useStyles()
    return (
        <a
            href={`/projects/${projectId}/workspace/${sectionElementId}`}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.goToSectionLink}
            onClick={(e) => e.stopPropagation()}
            data-testid="goToSectionLink"
        >
            Go to section →
        </a>
    )
}

export default GoToSectionLink
